module.exports = __webpack_public_path__ + "static/media/hotel-11.dc69e775.jpg";